import bloomGlacierCrush from "@/assets/staffer-pets/accessories/bloom-glacier-crush.png";
import blueLightsaber from "@/assets/staffer-pets/accessories/blue-lightsaber.png";
import candyBucket from "@/assets/staffer-pets/accessories/candy-bucket.png";
import crossbow from "@/assets/staffer-pets/accessories/crossbow.png";
import dragonCompanion from "@/assets/staffer-pets/accessories/dragon-companion.png";
import fireBreath from "@/assets/staffer-pets/accessories/fire-breath.png";
import floatingGhost from "@/assets/staffer-pets/accessories/floating-ghost.png";
import greenLightsaber from "@/assets/staffer-pets/accessories/green-lightsaber.png";
import handOfTheKingPin from "@/assets/staffer-pets/accessories/hand-of-the-king-pin.png";
import mandalorianJetpack from "@/assets/staffer-pets/accessories/mandalorian-jetpack.png";
import northernFurPelt from "@/assets/staffer-pets/accessories/northern-fur-pelt.png";
import redLightsaber from "@/assets/staffer-pets/accessories/red-lightsaber.png";
import sithLightning from "@/assets/staffer-pets/accessories/sith-lightning.png";
import tennisRacket from "@/assets/staffer-pets/accessories/tennis-racket.png";
import valyrianSteelSword from "@/assets/staffer-pets/accessories/valyrian-steel-sword.png";
import whiteMonsterCan from "@/assets/staffer-pets/accessories/white-monster-can.png";
import wineGoblet from "@/assets/staffer-pets/accessories/wine-goblet.png";
import witchBroom from "@/assets/staffer-pets/accessories/witch-broom.png";
import baldEagleNeutral from "@/assets/staffer-pets/bald-eagle-neutral.png";
import batNeutral from "@/assets/staffer-pets/bat-neutral.png";
import blueJayNeutral from "@/assets/staffer-pets/blue-jay-neutral.png";
import cardinalNeutral from "@/assets/staffer-pets/cardinal-neutral.png";
import catNeutral from "@/assets/staffer-pets/cat-neutral.png";
import cockatielNeutral from "@/assets/staffer-pets/cockatiel-neutral.png";
import crowNeutral from "@/assets/staffer-pets/crow-neutral.png";
import direwolfNeutral from "@/assets/staffer-pets/direwolf-neutral.png";
import dragonNeutral from "@/assets/staffer-pets/dragon-neutral.png";
import duneWormNeutral from "@/assets/staffer-pets/dune-worm-neutral.png";
import foxNeutral from "@/assets/staffer-pets/fox-neutral.png";
import kingfisherNeutral from "@/assets/staffer-pets/kingfisher-neutral.png";
import owlNeutral from "@/assets/staffer-pets/owl-neutral.png";
import phoenixNeutral from "@/assets/staffer-pets/phoenix-neutral.png";
import peterNatural from "@/assets/staffer-pets/peter-natural.png";
import peterNeutral from "@/assets/staffer-pets/peter-neutral.png";
import batPerch from "@/assets/staffer-pets/toppers/bat-perch.png";
import beansHat from "@/assets/staffer-pets/toppers/beans-hat.png";
import cowboyHat from "@/assets/staffer-pets/toppers/cowboy-hat.png";
import crown from "@/assets/staffer-pets/toppers/crown.png";
import hardHat from "@/assets/staffer-pets/toppers/hard-hat.png";
import hockeyMask from "@/assets/staffer-pets/toppers/hockey-mask.png";
import laborupCamoHat from "@/assets/staffer-pets/toppers/laborup-camo-hat.png";
import leiaBuns from "@/assets/staffer-pets/toppers/leia-buns.png";
import maestersCap from "@/assets/staffer-pets/toppers/maesters-cap.png";
import nightKingIceHorns from "@/assets/staffer-pets/toppers/night-king-ice-horns.png";
import northernFurHood from "@/assets/staffer-pets/toppers/northern-fur-hood.png";
import northernSteelHelmet from "@/assets/staffer-pets/toppers/northern-steel-helmet.png";
import platinumBraidedWig from "@/assets/staffer-pets/toppers/platinum-braided-wig.png";
import stormtrooperHelmet from "@/assets/staffer-pets/toppers/stormtrooper-helmet.png";
import vaderHelmet from "@/assets/staffer-pets/toppers/vader-helmet.png";
import winterIronCrown from "@/assets/staffer-pets/toppers/winter-iron-crown.png";
import witchHat from "@/assets/staffer-pets/toppers/witch-hat.png";
import wrenNeutral from "@/assets/staffer-pets/wren-neutral.png";

import type {
  Pet,
  PetAppearance,
  StafferPetPalette,
  StafferPetPaletteId,
  StafferPetSpecies,
  StafferPetTopperOffset,
} from "@/types";

const STAFFER_PET_TOPPER_OFFSET_LIMIT_PX = 96;
const STAFFER_PET_TOPPER_MIN_SCALE = 0.6;
const STAFFER_PET_TOPPER_MAX_SCALE = 1.6;
const NATURAL_PALETTE_ID: StafferPetPaletteId = "CORBIN";
const STAFFER_PET_BASE_PALETTE_IDS = [
  "EMBER",
  "MOSS",
  "OCEAN",
  "ORCHID",
] as const satisfies StafferPetPaletteId[];

const PALETTES = {
  RAINBOW: {
    label: "Rainbow",
    rarity: "LEGENDARY",
    rarityRank: 17,
    outline: "#20182E",
    shadow: "#53406C",
    body: "#F05C79",
    highlight: "#FFC76B",
    accentDark: "#5C4085",
    accent: "#52D7AE",
    accentLight: "#A68AF2",
    belly: "#FFF7ED",
    eye: "#241B32",
    eyeHighlight: "#FFFFFF",
  },
  EMBER: {
    label: "Ember",
    rarity: "COMMON",
    rarityRank: 1,
    outline: "#172033",
    shadow: "#C2410C",
    body: "#F97316",
    highlight: "#FDBA74",
    accentDark: "#312E81",
    accent: "#4F46E5",
    accentLight: "#A5B4FC",
    belly: "#FFF1D6",
    eye: "#1E1B4B",
    eyeHighlight: "#FFFFFF",
  },
  MOSS: {
    label: "Moss",
    rarity: "UNCOMMON",
    rarityRank: 2,
    outline: "#172033",
    shadow: "#3F6212",
    body: "#65A30D",
    highlight: "#BEF264",
    accentDark: "#365314",
    accent: "#4D7C0F",
    accentLight: "#A3E635",
    belly: "#FEF3C7",
    eye: "#1C1917",
    eyeHighlight: "#FFFFFF",
  },
  OCEAN: {
    label: "Ocean",
    rarity: "RARE",
    rarityRank: 3,
    outline: "#172033",
    shadow: "#0E7490",
    body: "#06B6D4",
    highlight: "#A5F3FC",
    accentDark: "#1E3A8A",
    accent: "#2563EB",
    accentLight: "#93C5FD",
    belly: "#ECFEFF",
    eye: "#172554",
    eyeHighlight: "#FFFFFF",
  },
  ORCHID: {
    label: "Orchid",
    rarity: "EPIC",
    rarityRank: 4,
    outline: "#1E1235",
    shadow: "#4C1D95",
    body: "#7C3AED",
    highlight: "#DDD6FE",
    accentDark: "#2E1065",
    accent: "#5B21B6",
    accentLight: "#C4B5FD",
    belly: "#FAF5FF",
    eye: "#2E1065",
    eyeHighlight: "#FFFFFF",
  },
  ROSE: {
    label: "Rose",
    rarity: "EPIC",
    rarityRank: 6,
    outline: "#3B0A1F",
    shadow: "#BE123C",
    body: "#F43F5E",
    highlight: "#FDA4AF",
    accentDark: "#881337",
    accent: "#E11D48",
    accentLight: "#FECDD3",
    belly: "#FFF1F2",
    eye: "#4C0519",
    eyeHighlight: "#FFFFFF",
  },
  GOLD: {
    label: "Gold",
    rarity: "LEGENDARY",
    rarityRank: 10,
    outline: "#3F2A1D",
    shadow: "#A16207",
    body: "#EAB308",
    highlight: "#FEF08A",
    accentDark: "#854D0E",
    accent: "#CA8A04",
    accentLight: "#FDE68A",
    belly: "#FFFBEB",
    eye: "#451A03",
    eyeHighlight: "#FFFFFF",
  },
  NEBULA: {
    label: "Nebula",
    rarity: "EPIC",
    rarityRank: 8,
    outline: "#0B0A2A",
    shadow: "#312E81",
    body: "#4338CA",
    highlight: "#22D3EE",
    accentDark: "#701A75",
    accent: "#C026D3",
    accentLight: "#F0ABFC",
    belly: "#EEF2FF",
    eye: "#F5D0FE",
    eyeHighlight: "#FFFFFF",
  },
  AURORA: {
    label: "Aurora",
    rarity: "RARE",
    rarityRank: 5,
    outline: "#0B1F2A",
    shadow: "#0D9488",
    body: "#2DD4BF",
    highlight: "#A7F3D0",
    accentDark: "#4C1D95",
    accent: "#7C3AED",
    accentLight: "#C4B5FD",
    belly: "#ECFEFF",
    eye: "#042F2E",
    eyeHighlight: "#FFFFFF",
  },
  BRONZE: {
    label: "Bronze",
    rarity: "EPIC",
    rarityRank: 7,
    outline: "#3A2114",
    shadow: "#7C3F1D",
    body: "#B87333",
    highlight: "#E2A66F",
    accentDark: "#4A2715",
    accent: "#9A572D",
    accentLight: "#EDC39B",
    belly: "#FFF7ED",
    eye: "#2A160D",
    eyeHighlight: "#FFFFFF",
  },
  SILVER: {
    label: "Silver",
    rarity: "LEGENDARY",
    rarityRank: 9,
    outline: "#26303D",
    shadow: "#64748B",
    body: "#CBD5E1",
    highlight: "#F1F5F9",
    accentDark: "#334155",
    accent: "#94A3B8",
    accentLight: "#E2E8F0",
    belly: "#FFFFFF",
    eye: "#1E293B",
    eyeHighlight: "#FFFFFF",
  },
  PHX_RED: {
    label: "PHX Red",
    rarity: "LEGENDARY",
    rarityRank: 11,
    outline: "#260408",
    shadow: "#7F0D1D",
    body: "#B91C32",
    highlight: "#FF8A3D",
    accentDark: "#5A0712",
    accent: "#F0441D",
    accentLight: "#FFD166",
    belly: "#FFE8B6",
    eye: "#3B0509",
    eyeHighlight: "#FFF7D6",
  },
  CENTRE_COURT: {
    label: "Centre Court",
    rarity: "EPIC",
    rarityRank: 12,
    outline: "#102A17",
    shadow: "#3F6212",
    body: "#A3E635",
    highlight: "#FACC15",
    accentDark: "#14532D",
    accent: "#65A30D",
    accentLight: "#FEF08A",
    belly: "#FFFDF4",
    eye: "#14210B",
    eyeHighlight: "#FFFFFF",
  },
  CHAMPIONSHIP_WHITE: {
    label: "Championship White",
    rarity: "EPIC",
    rarityRank: 13,
    outline: "#17321A",
    shadow: "#65A30D",
    body: "#F1F5F9",
    highlight: "#FDE047",
    accentDark: "#3F6212",
    accent: "#84CC16",
    accentLight: "#D9F99D",
    belly: "#FFFFFF",
    eye: "#172033",
    eyeHighlight: "#FFFFFF",
  },
  CORBIN: {
    label: "Natural",
    rarity: "EPIC",
    rarityRank: 15,
    outline: "#272520",
    shadow: "#43423E",
    body: "#9D462E",
    highlight: "#C07A5F",
    accentDark: "#3F3830",
    accent: "#686762",
    accentLight: "#8D8A83",
    belly: "#D5D3CE",
    eye: "#272520",
    eyeHighlight: "#F5F4EF",
  },
  NONE: {
    label: "",
    rarity: "RARE",
    rarityRank: 14,
    outline: "#1E293B",
    shadow: "#475569",
    body: "#64748B",
    highlight: "#94A3B8",
    accentDark: "#334155",
    accent: "#64748B",
    accentLight: "#94A3B8",
    belly: "#CBD5E1",
    eye: "#1E293B",
    eyeHighlight: "#FFFFFF",
  },
} as const satisfies Record<StafferPetPaletteId, StafferPetPalette>;

// Prestige colorways glow so they stand apart in the yard and previews.
const GLOW_PALETTE_IDS: StafferPetPaletteId[] = [
  "NEBULA",
  "SILVER",
  "GOLD",
  "PHX_RED",
];

const TOPPERS = {
  NORTHERN_STEEL_HELMET: {
    label: "Northern Steel Helmet",
    src: northernSteelHelmet,
    anchorX: 128,
    anchorY: 145,
    widthPercent: 58,
  },
  NIGHT_KING_ICE_HORNS: {
    label: "Night King Ice Horns",
    src: nightKingIceHorns,
    anchorX: 128,
    anchorY: 175,
    widthPercent: 52,
  },
  MAESTERS_CAP: {
    label: "Maester's Cap",
    src: maestersCap,
    anchorX: 128,
    anchorY: 184,
    widthPercent: 54,
  },
  PLATINUM_BRAIDED_WIG: {
    label: "Platinum Braided Wig",
    src: platinumBraidedWig,
    anchorX: 155,
    anchorY: 100,
    widthPercent: 64,
  },
  NORTHERN_FUR_HOOD: {
    label: "Northern Fur Hood",
    src: northernFurHood,
    anchorX: 137,
    anchorY: 90,
    widthPercent: 68,
  },
  CROWN: {
    label: "Crown",
    src: crown,
    anchorX: 128,
    anchorY: 230,
    widthPercent: 50,
  },
  HOCKEY_MASK: {
    label: "Hockey Mask",
    src: hockeyMask,
    anchorX: 128,
    anchorY: 72,
    widthPercent: 55,
  },
  LABORUP_CAMO_HAT: {
    label: "Laborup Camo Hat",
    src: laborupCamoHat,
    anchorX: 128,
    anchorY: 210,
    widthPercent: 50,
  },
  BAT_PERCH: {
    label: "Bat Perch",
    src: batPerch,
    anchorX: 128,
    anchorY: 220,
    widthPercent: 44,
  },
  COWBOY_HAT: {
    label: "Cowboy Hat",
    src: cowboyHat,
    anchorX: 128,
    anchorY: 160,
    widthPercent: 48,
  },
  BEANS_HAT: {
    label: "BEANS Hat",
    src: beansHat,
    anchorX: 145,
    anchorY: 190,
    widthPercent: 40,
  },
  HARD_HAT: {
    label: "Laborup Hard Hat",
    src: hardHat,
    anchorX: 128,
    anchorY: 205,
    widthPercent: 40,
  },
  LEIA_BUNS: {
    label: "Leia Buns",
    src: leiaBuns,
    anchorX: 128,
    anchorY: 170,
    widthPercent: 58,
  },
  STORMTROOPER_HELMET: {
    label: "Stormtrooper Helmet",
    src: stormtrooperHelmet,
    anchorX: 128,
    anchorY: 230,
    widthPercent: 54,
  },
  VADER_HELMET: {
    label: "Vader Helmet",
    src: vaderHelmet,
    anchorX: 128,
    anchorY: 230,
    widthPercent: 54,
  },
  WITCH_HAT: {
    label: "Witch Hat",
    src: witchHat,
    anchorX: 128,
    anchorY: 230,
    widthPercent: 48.4,
  },
} as const;

const ACCESSORIES = {
  HAND_OF_THE_KING_PIN: {
    label: "Hand of the King Pin",
    src: handOfTheKingPin,
    defaultX: 15,
    defaultY: 24,
    rotation: 0,
    widthPercent: 25,
  },
  CROSSBOW: {
    label: "Crossbow",
    src: crossbow,
    defaultX: 28,
    defaultY: 30,
    rotation: 0,
    widthPercent: 60,
  },
  NORTHERN_FUR_PELT: {
    label: "Northern Fur Pelt",
    src: northernFurPelt,
    defaultX: 0,
    defaultY: 32,
    rotation: 0,
    widthPercent: 70,
  },
  DRAGON_COMPANION: {
    label: "Dragon Companion",
    src: dragonCompanion,
    defaultX: 63,
    defaultY: 43,
    rotation: 0,
    widthPercent: 44,
  },
  VALYRIAN_STEEL_SWORD: {
    label: "Valyrian Steel Sword",
    src: valyrianSteelSword,
    defaultX: 36,
    defaultY: 20,
    rotation: 0,
    widthPercent: 66,
  },
  WINE_GOBLET: {
    label: "Wine Goblet",
    src: wineGoblet,
    defaultX: 44,
    defaultY: 33,
    rotation: 0,
    widthPercent: 35,
  },
  FLOATING_GHOST: {
    defaultX: 55,
    defaultY: -28,
    label: "Floating Ghost",
    rotation: 0,
    src: floatingGhost,
    widthPercent: 58,
  },
  CANDY_BUCKET: {
    defaultX: 36,
    defaultY: 30,
    label: "Candy Bucket",
    rotation: 0,
    src: candyBucket,
    widthPercent: 44,
  },
  BLOOM_GLACIER_CRUSH: {
    defaultX: 35,
    defaultY: 30,
    label: "Bloom Glacier Crush",
    rotation: 0,
    src: bloomGlacierCrush,
    widthPercent: 48,
  },
  BLUE_LIGHTSABER: {
    defaultX: 0,
    defaultY: 0,
    label: "Blue Lightsaber",
    rotation: 0,
    src: blueLightsaber,
    widthPercent: 54,
  },
  GREEN_LIGHTSABER: {
    defaultX: 0,
    defaultY: 0,
    label: "Green Lightsaber",
    rotation: 0,
    src: greenLightsaber,
    widthPercent: 54,
  },
  RED_LIGHTSABER: {
    defaultX: 0,
    defaultY: 0,
    label: "Red Lightsaber",
    rotation: 0,
    src: redLightsaber,
    widthPercent: 54,
  },
  MANDALORIAN_JETPACK: {
    defaultX: -45,
    defaultY: 0,
    label: "Mandalorian Jetpack",
    rotation: 0,
    src: mandalorianJetpack,
    widthPercent: 90,
  },
  FIRE_BREATH: {
    defaultX: 65,
    defaultY: -15,
    label: "Fire Breath",
    rotation: 0,
    src: fireBreath,
    widthPercent: 66,
  },
  WITCH_BROOM: {
    defaultX: 32,
    defaultY: 10,
    label: "Witch Broom",
    rotation: 0,
    src: witchBroom,
    widthPercent: 65,
  },
  SITH_LIGHTNING: {
    defaultX: 35,
    defaultY: -10,
    label: "Sith Lightning",
    rotation: 48,
    src: sithLightning,
    widthPercent: 66,
  },
  WHITE_MONSTER_CAN: {
    defaultX: 35,
    defaultY: 30,
    label: "White Monster Can",
    rotation: 0,
    src: whiteMonsterCan,
    widthPercent: 48,
  },
  TENNIS_RACKET: {
    defaultX: 30,
    defaultY: 15,
    label: "Tennis Racket",
    rotation: 0,
    src: tennisRacket,
    widthPercent: 78,
  },
} as const;

// Restricted species are custom unlocks — they only show up for accounts
// whose pet has the species in unlocked.petIds.
interface SpeciesOption {
  id: StafferPetSpecies;
  label: string;
  isRestricted?: boolean;
}

const AVAILABLE_SPECIES: readonly SpeciesOption[] = [
  { id: "FOX", label: "FOX" },
  { id: "DRAGON", label: "DRAGON" },
  { id: "CAT", label: "CAT" },
  { id: "BLUE_JAY", label: "BLUE JAY" },
  { id: "CARDINAL", label: "CARDINAL" },
  { id: "COCKATIEL", label: "COCKATIEL" },
  { id: "KINGFISHER", label: "KINGFISHER" },
  { id: "OWL", label: "OWL" },
  { id: "CROW", label: "CROW" },
  { id: "WREN", label: "WREN" },
  { id: "BALD_EAGLE", label: "BALD EAGLE" },
  { id: "DUNE_WORM", label: "Shai-Hulud", isRestricted: true },
  { id: "BAT", label: "BAT", isRestricted: true },
  { id: "PHOENIX", label: "Phoenix", isRestricted: true },
  { id: "DIREWOLF", label: "Direwolf", isRestricted: true },
  { id: "PETER", label: "Peter", isRestricted: true },
];

const getSpeciesLabel = (species: StafferPetSpecies): string =>
  AVAILABLE_SPECIES.find((option) => option.id === species)?.label ??
  species.replace(/_/g, " ");

// The safeguard for custom-unlock species: restricted ids are selectable only
// when the pet has actually unlocked them.
const getSelectableSpecies = (pet: Pet | null): SpeciesOption[] =>
  AVAILABLE_SPECIES.filter(
    (option) =>
      !option.isRestricted || (pet?.unlocked.petIds ?? []).includes(option.id),
  );

const DEFAULT_PALETTE_BY_SPECIES: Record<
  StafferPetSpecies,
  StafferPetPaletteId
> = {
  FOX: "EMBER",
  DRAGON: "EMBER",
  CAT: "EMBER",
  BLUE_JAY: "EMBER",
  CARDINAL: "EMBER",
  COCKATIEL: "EMBER",
  KINGFISHER: "EMBER",
  OWL: "EMBER",
  CROW: "EMBER",
  WREN: "EMBER",
  BALD_EAGLE: "EMBER",
  DUNE_WORM: "EMBER",
  BAT: "EMBER",
  PHOENIX: "EMBER",
  DIREWOLF: "OCEAN",
  PETER: "EMBER",
};

const SPRITE_BY_SPECIES_AND_PALETTE: Record<StafferPetSpecies, string> = {
  FOX: foxNeutral,
  DRAGON: dragonNeutral,
  CAT: catNeutral,
  BLUE_JAY: blueJayNeutral,
  CARDINAL: cardinalNeutral,
  COCKATIEL: cockatielNeutral,
  KINGFISHER: kingfisherNeutral,
  OWL: owlNeutral,
  CROW: crowNeutral,
  WREN: wrenNeutral,
  BALD_EAGLE: baldEagleNeutral,
  DUNE_WORM: duneWormNeutral,
  BAT: batNeutral,
  PHOENIX: phoenixNeutral,
  DIREWOLF: direwolfNeutral,
  PETER: peterNeutral,
};

// Shai-Hulud's art fills its whole canvas while the other pets have padding,
// so at the same size it reads noticeably bigger; shrink it to match.
const DISPLAY_SCALE_BY_SPECIES: Partial<Record<StafferPetSpecies, number>> = {
  DUNE_WORM: 0.78,
};

const getDisplaySizePx = (species: StafferPetSpecies, sizePx: number) =>
  Math.round(sizePx * (DISPLAY_SCALE_BY_SPECIES[species] ?? 1));

const getSpriteSrc = (
  species: StafferPetSpecies,
  paletteId?: StafferPetPaletteId,
): string => {
  if (species === "PETER" && paletteId === NATURAL_PALETTE_ID)
    return peterNatural;
  return SPRITE_BY_SPECIES_AND_PALETTE[species];
};

const getPalette = (
  species: StafferPetSpecies,
  paletteId?: StafferPetPaletteId,
): StafferPetPalette => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  return PALETTES[paletteId || DEFAULT_PALETTE_BY_SPECIES[species]];
};

const isSpeciesId = (value: unknown): value is StafferPetSpecies =>
  typeof value === "string" && value in SPRITE_BY_SPECIES_AND_PALETTE;

const isPaletteId = (value: unknown): value is StafferPetPaletteId =>
  typeof value === "string" && value in PALETTES;

const isBasePaletteId = (paletteId: StafferPetPaletteId): boolean =>
  STAFFER_PET_BASE_PALETTE_IDS.some((baseId) => baseId === paletteId);

const getUnlockedExclusiveColorIds = (pet: Pet): StafferPetPaletteId[] =>
  pet.unlocked.colorIds
    .filter(isPaletteId)
    .filter((paletteId) => !isBasePaletteId(paletteId));

// The crown is never equipped from the shop — the server grants it to last
// month's top revenue earner, and it overrides their equipped topper.
const CROWN_TOPPER_ID = "CROWN";

const getWornTopperId = (
  pet: PetAppearance,
  options?: { isOnLeaderboard?: boolean },
): string | null => {
  const showsCrown =
    pet.isCrowned === true &&
    (options?.isOnLeaderboard === true || pet.isCrownLeaderboardOnly !== true);
  if (showsCrown) return CROWN_TOPPER_ID;
  // Legacy equips of the old shop crown no longer render.
  if (pet.equipped.topperId === CROWN_TOPPER_ID) return null;
  return pet.equipped.topperId;
};

const getTopper = (topperId: string | null) => {
  if (topperId === null || !(topperId in TOPPERS)) return null;
  // November's leader crown is a visual swap only; the original stays intact.
  if (
    topperId === CROWN_TOPPER_ID &&
    Date.now() >= Date.parse("2026-11-01T00:00:00-05:00") &&
    Date.now() < Date.parse("2026-12-01T00:00:00-06:00")
  ) {
    return { ...TOPPERS.CROWN, src: winterIronCrown, anchorY: 180 };
  }
  return TOPPERS[topperId as keyof typeof TOPPERS];
};

const getAccessory = (accessoryId: string | null | undefined) => {
  if (!accessoryId || !(accessoryId in ACCESSORIES)) return null;
  return ACCESSORIES[accessoryId as keyof typeof ACCESSORIES];
};

const getTopperOffsetKey = (
  species: StafferPetSpecies,
  topperId: string,
): string => `${species}:${topperId}`;

const getAccessoryAdjustmentKey = (
  species: StafferPetSpecies,
  accessoryId: string,
): string => `${species}:${accessoryId}`;

const clampTopperOffset = (
  offset: StafferPetTopperOffset,
  topperId?: string | null,
): StafferPetTopperOffset => ({
  x: Math.max(
    -STAFFER_PET_TOPPER_OFFSET_LIMIT_PX,
    Math.min(offset.x, STAFFER_PET_TOPPER_OFFSET_LIMIT_PX),
  ),
  y: Math.max(
    -STAFFER_PET_TOPPER_OFFSET_LIMIT_PX,
    Math.min(offset.y, STAFFER_PET_TOPPER_OFFSET_LIMIT_PX),
  ),
  scale: Math.max(
    STAFFER_PET_TOPPER_MIN_SCALE,
    Math.min(
      offset.scale || 1,
      topperId === "HOCKEY_MASK"
        ? 2.2
        : STAFFER_PET_TOPPER_MAX_SCALE * (topperId === "WITCH_HAT" ? 1.1 : 1),
    ),
  ),
  rotation:
    offset.rotation === undefined
      ? undefined
      : ((offset.rotation % 360) + 360) % 360,
});

const clampAccessoryAdjustment = (
  adjustment: StafferPetTopperOffset,
  accessoryId: string | null | undefined,
): StafferPetTopperOffset => {
  const accessory = getAccessory(accessoryId);
  const normalized = clampTopperOffset(adjustment);
  if (accessory === null) return normalized;

  const x = Number.isFinite(adjustment.x) ? adjustment.x : 0;
  const y = Number.isFinite(adjustment.y) ? adjustment.y : 0;
  return {
    ...normalized,
    x: Math.max(
      -128 - accessory.defaultX,
      Math.min(x, 128 - accessory.defaultX),
    ),
    y: Math.max(
      -128 - accessory.defaultY,
      Math.min(y, 128 - accessory.defaultY),
    ),
  };
};

const getTopperOffset = (
  topperOffsets: unknown,
  species: StafferPetSpecies,
  topperId: string | null,
): StafferPetTopperOffset => {
  if (
    topperId === null ||
    typeof topperOffsets !== "object" ||
    topperOffsets === null
  ) {
    return { x: 0, y: 0 };
  }

  const offsets = topperOffsets as Record<string, unknown>;
  const offset = offsets[getTopperOffsetKey(species, topperId)];
  if (typeof offset !== "object" || offset === null) return { x: 0, y: 0 };

  const { x, y, scale } = offset as Partial<StafferPetTopperOffset>;
  if (
    typeof x !== "number" ||
    typeof y !== "number" ||
    !Number.isFinite(x) ||
    !Number.isFinite(y)
  ) {
    return { x: 0, y: 0 };
  }

  return clampTopperOffset(
    {
      x,
      y,
      scale: typeof scale === "number" && Number.isFinite(scale) ? scale : 1,
    },
    topperId,
  );
};

const getAccessoryAdjustment = (
  adjustments: unknown,
  species: StafferPetSpecies,
  accessoryId: string | null | undefined,
): StafferPetTopperOffset => {
  if (!accessoryId || typeof adjustments !== "object" || adjustments === null) {
    return { x: 0, y: 0, scale: 1 };
  }

  const savedAdjustments = adjustments as Record<string, unknown>;
  const adjustment =
    savedAdjustments[getAccessoryAdjustmentKey(species, accessoryId)];
  if (typeof adjustment !== "object" || adjustment === null) {
    return { x: 0, y: 0, scale: 1 };
  }

  const { x, y, scale, rotation } =
    adjustment as Partial<StafferPetTopperOffset>;
  if (
    typeof x !== "number" ||
    typeof y !== "number" ||
    !Number.isFinite(x) ||
    !Number.isFinite(y)
  ) {
    return { x: 0, y: 0, scale: 1 };
  }

  return clampAccessoryAdjustment(
    {
      x,
      y,
      scale: typeof scale === "number" && Number.isFinite(scale) ? scale : 1,
      rotation:
        typeof rotation === "number" && Number.isFinite(rotation)
          ? rotation
          : undefined,
    },
    accessoryId,
  );
};

// A `useGetPets` select: keeps only the sprite fields. Module-level so the
// select stays referentially stable and react-query can reuse its result.
const toAppearances = (pets: Pet[]): PetAppearance[] =>
  pets.map((pet) => ({
    userId: pet.userId,
    equipped: pet.equipped,
    topperOffsets: pet.topperOffsets,
    accessoryAdjustments: pet.accessoryAdjustments,
    isCrowned: pet.isCrowned,
    isCrownLeaderboardOnly: pet.isCrownLeaderboardOnly,
  }));

export const stafferPets = {
  toAppearances,
  NATURAL_PALETTE_ID,
  ACCESSORIES,
  AVAILABLE_SPECIES,
  BASE_PALETTE_IDS: STAFFER_PET_BASE_PALETTE_IDS,
  PALETTES,
  GLOW_PALETTE_IDS,
  TOPPERS,
  CROWN_TOPPER_ID,
  DEFAULT_PALETTE_BY_SPECIES,
  clampTopperOffset,
  clampAccessoryAdjustment,
  getSelectableSpecies,
  getDisplaySizePx,
  getSpeciesLabel,
  getAccessory,
  getAccessoryAdjustment,
  getAccessoryAdjustmentKey,
  getUnlockedExclusiveColorIds,
  getSpriteSrc,
  getPaletteSwatchBackground: (id: StafferPetPaletteId) =>
    id === "RAINBOW"
      ? "linear-gradient(135deg, #f95170, #ffa24c, #ffe15e, #4bd695, #42aff4, #976cef, #ed70cb)"
      : PALETTES[id].body,
  getPalette,
  getTopper,
  getWornTopperId,
  getTopperOffset,
  getTopperOffsetKey,
  isBasePaletteId,
  isPaletteId,
  isSpeciesId,
};
